// extracted by mini-css-extract-plugin
module.exports = {"productInfoContainer":"productInfo_productInfoContainer__dFFib"};